export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Greška inicijalizacije",
    "StaticConfigLoader.caption.init": "Inicijalizacija",
    "StaticConfigLoader.text.init": "Inicijalizacija aplikacije...",
    "StaticConfigLoader.error.settings": "Učitavanje podešavanja sajta nije uspelo",
    "StaticConfigLoader.error.circuits": "Učitavanje kofiguracije usluga nije uspelo",
    //app
    "Legal.Localization": "sr",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Terms and Conditions",
    "Legal.TermsService": "Terms of Service",
    "Legal.PrivacyPolicy": "Privacy Policy",
    "Legal.CookiesPolicy": "Podešavanja kolačića",
    "Legal.Copyright": "All trademarks, logos and brand names are the property of their respective owners.",
    "AchievementApp.Navbar.achievement": "Lično dostignuće",
    "AchievementApp.Navbar.userAchievement": "Dostignuće korisnika",
    "AchievementApp.Navbar.settingsLink": "Podešavanja",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Ponovo se prijavite ili promenite nalog",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net Dostignuća",
    //commonAssets
    "ViewItemDetailed.state.completed": "Završeno",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Fitriraj po naslovima",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Moji prijatelji",
    "UserFriendsList.heading.showMore": "Prikaži više",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Treba da konfigurišete autorizaciju sa dva faktora",
    "LimitedAccountPanel.2step.link": "Više o autorizaciji sa dva faktora",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Treba da potvrdite imejl adresu",
    "LimitedAccountPanel.email.link": "Nastavi na profil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Vaš nalog je ograničen zbog:",
    "LimitedAccountPanel.conclusion": "Nakon promene sigurnosnih podešavanja treba da se odjavite i ponovo prijavite da bi se promene primenile",
    "LimitedAccountPanel.relogin": "Ponovo se prijavi",
    "EmailVerificationStateIcon.success": "Nalog je potvrđen, imejl adresa proverena",
    "EmailVerificationStateIcon.warning": "Nalog nije potvrđen, imejl adresa nije proverena",
    "EmailVerificationStateIcon.danger": "Nalog nije potvrđen, potvrda imejl adrese je OBAVEZNA",
    "TwoFactorStateIcon.success": "Nalog je zaštićen autorizacijom sa dva faktora",
    "TwoFactorStateIcon.warning": "Nebezbedan nalog, autorizacija sa dva faktora je onemogućena",
    "TwoFactorStateIcon.danger": "Autorizacija sa dva faktora je OBAVEZNA",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Sačuvaj podešavanja",
    "UserSettingDialog.settings": "Podešavanja",
    "UserSettingDialog.userSettings": "Korisnička podešavanja",
    "UserSettingDialog.language": "Jezik",
    "UserSettingDialog.privacy": "Privatnost",
    "UserSettingDialog.allUsers": "Svi korisnici",
    "UserSettingDialog.friendsOnly": "Samo prijatelji",
    "UserSettingDialog.onlyMe": "Samo ja",
    "UserSettingDialog.whoCanView": "Ko može da vidi moja dostignuća",
    //unlockProgress
    "ViewUnlockProgress.of": " od ",
    "ViewUnlockProgress.achievCompleted": " završenih dostignuća",
    "ViewUnlockProgress.myUnlock": "Moja dostignuća",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Unesite nadimak ovde",
    "ViewItemSearch.label.search": "Pretraga korisnika",
    "ViewItemSearch.resultNotFound": "Korisnik nije pronađen",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Dostignuće",
    "ViewItemSearch.stub.empty": "Nema dostignuća",
    "ViewItemSearch.stub.emptyCompare_1": "Korisnik ",
    "ViewItemSearch.stub.emptyCompare_2": " nema dostignuća u ovoj igri",
    "ViewItemSearch.limitedAccess": "Pristup dostignućima izabranog korisnika je ograničen",
    "ViewItemSearch.heading.selectGame": "Izaberite igru sa liste",
    "ViewItemSearch.globalstat.opened": "otključano od strane ",
    "ViewItemSearch.globalstat.ofGamers": "% igrača",
    //authentication
    "NotAllowedMessage.caption": "Nije dozvoljen",
    "NotAllowedMessage.body.h1": "Pristup dostignućima",
    "NotAllowedMessage.body.h3": "trenutno nije dozvoljen za vaš nalog",
    "NotAllowedMessage.relogin": "Promeni nalog",
    "LandingMessage.caption": "Potvrda identiteta",
    "LandingMessage.body": "Završne provere...",
    "TokenExpiredMessage.caption": "Potvrda identiteta je istekla",
    "TokenExpiredMessage.body.h3": "Ne možemo mnogo da uradimo s ovim, ali vi ipak možete",
    "TokenExpiredMessage.relogin": "Ponovo se prijavi",
    "AuthErrorMessage.caption": "Potvrda identiteta nije uspela",
    "AuthErrorMessage.body.h1": "Provera potvrde identiteta nije uspela",
    "AuthErrorMessage.body.code": "Kôd",
    "AuthErrorMessage.body.desc": "Ne možemo mnogo da uradimo s ovim, ali vi ipak možete",
    "AuthErrorMessage.relogin": "Ponovo se prijavi",
    "AuthorizationRequiredMessage.caption": "Potrebna je potvrda identiteta",
    "AuthorizationRequiredMessage.body.h3.1": "Ući ćete u",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Ali treba vam ovlašćenje da biste nastavili dalje",
    "AuthorizationRequiredMessage.login": "Prijavi se sa Gaijin.Net",
    "CheckingAuthMessage.caption": "Potvrda identiteta",
    "CheckingAuthMessage.body": "Proverava se potvrda identiteta, molimo za strpljenje",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Mobilna verzija trenutno nije dostupna",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Koristite verziju za računar",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Izvinjavamo se",
}